import PropTypes from 'prop-types';

const genericQuestionPropType = PropTypes.shape({
  clientUuid: PropTypes.string.isRequired,
  id: PropTypes.string,
  type: PropTypes.string.isRequired,
  plainText: PropTypes.string,
  alignment: PropTypes.string,
  backgroundColor: PropTypes.string,
  buttons: PropTypes.array,
  color: PropTypes.string,
  size: PropTypes.string,
  content: PropTypes.object,
  display: PropTypes.bool,
  font: PropTypes.string,
  label: PropTypes.string,
  layout: PropTypes.string,
  limit: PropTypes.number,
  listStyle: PropTypes.string,
  maximumCharacters: PropTypes.number,
  midpointLabels: PropTypes.array,
  options: PropTypes.array,
  page: PropTypes.number,
  range: PropTypes.number,
  remaining: PropTypes.bool,
  required: PropTypes.bool,
  shape: PropTypes.string,
  showIndex: PropTypes.bool,
  textColor: PropTypes.string,
  segment: PropTypes.string,
  numbering: PropTypes.string,
}).isRequired;

export default genericQuestionPropType;
